import React from "react";
import { Button } from "antd";
import { useCreateWebpageVisualSeoAnalysisProcessMutation } from "../service";

type Props = {
    wGuid: string;
    url: string;
    inProgress: boolean;
    setIsRefreshingAnalysis: (isLoading: boolean) => void;
};


export default function RefreshVisualSeoAnalysisButton({ inProgress, wGuid, url, setIsRefreshingAnalysis }: Props) {
    const [isLoading, setIsLoading] = React.useState(inProgress);
    const [startVisualSeoAnalysis] = useCreateWebpageVisualSeoAnalysisProcessMutation();

    const handleRefreshAnalysis = async () => {
        setIsLoading(true);
        setIsRefreshingAnalysis(true);
        await startVisualSeoAnalysis({ wGuid, url }).unwrap();
        setIsRefreshingAnalysis(false);
    }

    React.useEffect(() => {
        setIsLoading(inProgress);
    }, [inProgress]);

    return (
        <Button
            className="refresh-analysis-button"
            size="small"
            loading={isLoading}
            onClick={handleRefreshAnalysis}
            icon={"sync"}
        >
            Refresh analysis
        </Button>
    );
}
